import { SymbolEventColumn } from 'widgets/corpActions/widget/grid/columnDefinitions';
import { GridDetailsPanelColumnDef } from 'utils/components/GridDetailsPanel/gridDetailsPanelColumnDef';

const cashDividend: GridDetailsPanelColumnDef<SymbolEventColumn>[] = [
    {
        controls: [
            { type: 'field', field: 'recordDate' },
            { type: 'field', field: 'dividendCurrency' },
            { type: 'field', field: 'adjustmentFactor' },
            { type: 'field', field: 'capitalChangeType' },
        ],
    },
    {
        controls: [
            { type: 'field', field: 'exDate' },
            { type: 'field', field: 'payDate' },
            { type: 'field', field: 'dividendFreq' },
            { type: 'field', field: 'dividendGrossAmount' },
        ],
    },
];

export default cashDividend;
